import { ReactComponent } from "./ic_search.svg";

interface Props {
  fill?: string;
}

const SearchLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default SearchLineIcon;
